module.exports = __webpack_public_path__ + "7d96767572a8565473acf877e58f04c9.pdf";